import script from "./CharacterCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./CharacterCounter.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"CharacterCounter.vue"]])

export default __exports__